module.exports = __webpack_public_path__ + "static/media/logo.400518bf.svg";